export const borderedDatePickerContainerStyle = {
  borderColor: '#D3DCE6',
  borderWidth: 1,
  borderRadius: 8,
  paddingLeft: 8,
  paddingRight: 8,
  paddingTop: 4,
  marginTop: -2,
  minHeight: 40
}

export const borderedInputStyle = {
  paddingLeft: 10,
  marginTop: 4,
  minHeight: 40
}

export const borderedSelectStyle = {
  marginTop: 4,
  minHeight: 40,
  paddingTop: 2
}

export const borderedSelectSearchStyle = {
  borderColor: '#D3DCE6',
  borderWidth: 1,
  borderRadius: 8,
  paddingLeft: 10,
  paddingRight: 10,
  marginTop: 4,
  minHeight: 40
}

export const statusStyles = {
  paddingTop: 4,
  paddingRight: 10,
  paddingBottom: 4,
  paddingLeft: 10,
  borderRadius: '999px',
  fontWeight: 'bold',
  fontSize: '12px',
  width: 'fit-content',
  textAlign: 'center',
  whiteSpace: 'nowrap'
}
